"use client";

import { useEffect, useState } from "react";
import SignUpButton from "@/components/SignUpButton";

export default function HomePageCtaSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.3 }
    );
    const section = document.getElementById('cta-section');
    if (section) observer.observe(section);
    return () => { if (section) observer.unobserve(section); };
  }, []);

  return (
    <section id="cta-section" className="bg-gradient-to-r from-orange-500 to-orange-600 py-16 lg:py-20">
      <div className="container mx-auto max-w-7xl px-6 lg:px-8 text-center">
        <h2 className={`text-3xl font-bold tracking-tight text-white sm:text-4xl transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          Walk Into Every Meeting Prepared
        </h2>
        <p className={`mt-4 text-lg text-orange-100 max-w-2xl mx-auto transition-all duration-700 ease-out delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          Start with 5 free prospects. Briefs are unlimited. No credit card.
        </p>
        <div className={`mt-8 transition-all duration-700 ease-out delay-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <SignUpButton className="bg-white text-orange-600 hover:bg-gray-50 px-8 py-3.5 text-base font-semibold rounded-xl shadow-lg" />
        </div>
      </div>
    </section>
  );
}
